import http from '../utils/http'
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *
 */
export default{
	/*****
	**@param params 请求传递的参数
	* post get 根据自己情况
	******/
	/*****
	**获取轮播图
	******/	
 	bannerImg(params){
    	return http.post('/home/banner/get',params)
	},
	/*****
	**获取视频
	******/
	bannerVideo(params){
		return http.get(`/home/banner/video`,params)
	},
	/*****
	**
	******/
	getProduct(url,params){
		return http.get(url,params)
	},
	/*****
	**搜索
	******/
	getSearch(params){
		return http.get(`/search`,params)
	},
	/*****
	**提交邮件
	******/
	getMessage(params){
		return http.post(`/user/leave/message/submit`,params)
	},
	/*****
	**是否登录超时
	******/
	getAccount(params){
		return http.get(`/user/account`,params)
	},
	/*****
	**专题
	******/
	getSubject(url,params){
		return http.get(`/product/subject/detail${url}`,params)
	},
	/*****
	**登录
	******/
	getLogin(params){
		return http.post(`/login`,params)
	},
	/*****
	**检查手机号
	******/
	getCheckMobile(params){
		return http.post(`/checkMobile`,params)
	},
	/*****
	**检查邮箱
	******/
	getCheckEmail(params){
		return http.post(`/checkEmail`,params)
	},
	/*****
	**发送邮箱验证码
	******/
	getMailcode(params){
		return http.post(`/passport/sendEmailAuthcode`,params)
	},
	/*****
	**发送手机验证码
	******/
	getSmscode(params){
		return http.post(`/sms/sendSmsAuthcode`,params)
	},
	/*****
	**发送手机验证码
	******/
	getCodeuid(params){
		return http.post(`/authcode/uid`,params)
	},
	/*****
	**注册
	******/
	getRegister(params){
		return http.post(`/register`,params)
	},
	/*****
	**短信验证码判断
	******/
	checkSmscode(params){
		return http.post(`/sms/hasSmsAuthcode`,params)
	},
	/*****
	**邮箱验证码判断
	******/
	checkMailscode(params){
		return http.post(`/passport/hasEmailAuthcode`,params)
	},
	/*****
	**退出登录
	******/
	getLogout(params){
		return http.post(`/logout`,params)
	},
	/*****
	**邮箱修改密码
	******/
	getCodepwd(url,params){
		return http.post(url,params)
	},
	/*****
	**短信修改密码
	******/
	getMailpwd(params){
		return http.post(`/sms/doResetPwd2`,params)
	},
	/*****
	**注册时判断名字是否注册过
	******/
	checkRegname(params){
		return http.post(`/checkUserName`,params)
	},
	/*****
	**图片信息
	******/
	getDetail(url,params){
		return http.post(`/product/detail/${url}`,params)
	},
	/*****
	**图片关键词
	******/
	getKeyList(url,params){
		return http.get(`/product/keyword/detail/${url}`,params)
	},
	/*****
	**详情页相似图片
	******/
	getSimImg(params){
		return http.get(`/search`,params)
	},
	/*****
	**相似视频
	******/
	getSimVideo(url,params){
		return http.get(`/search/similarOtherMedia/${url}`,params)
	},
	/*****
	**最近浏览
	******/
	getVisitList(url,params){
		return http.get(`/visit${url}`,params)
	},
	/*****
	**下载小样图
	******/
	textural(url,params){
		return http.post(`/user/download/textural/authenticate/${url}`,params)
	},
	/*****
	**下载小样图
	******/
	texturalTrue(url,params){
		return http.post(`/user/download/textural/${url}`,params)
	},
	/*****
	**下载小样图
	******/
	texturalTrue(params){
		return http.post(`/user/download/textural`,params)
	},
	/*****
	***@order
	**优惠券
	******/
	getcoupon(params){
		return http.post(`/coupon/unused`,params)
	},
	/*****
	**提交订单
	******/
	saveMobile(params){
		return http.post(`/order/saveForMobile`,params)
	},
	/*****
	**订单列表
	******/
	getOrderList(url,params){
		return http.get(`/order/list${url}`,params)
	},
	/*****
	**下载列表
	******/
	getDownList(url,params){
		return http.get(`/user/download/list${url}`,params)
	},
	/*****
	**删除订单
	******/
	deleteOrder(params){
		return http.post(`/order/delete`,params)
	},
	/*****
	**取消订单
	******/
	cancelOrder(params){
		return http.post(`/order/cancel`,params)
	},
	/*****
	**购物车列表
	******/
	getCarList(url,params){
		return http.get(`/cart/list${url}`,params)
	},
	/*****
	**添加授权
	******/
	updateCust(params){
		return http.post(`/cart/updateCustomer`,params)
	},
	/*****
	**购物车选中状态
	******/
	changeSelect(params){
		return http.post(`/cart/changeSelect`,params)
	},
	/*****
	**删除购物车
	******/
	deletaCart(params){
		return http.post(`/cart/delete`,params)
	},
	/*****
	***@account
	**客服通知
	******/
	getMessage(params){
		return http.get(`/user/message/get`,params)
	},
	/*****
	***@account
	**删除客服通知
	******/
	delMessage(params){
		return http.post(`/user/message/delete`,params)
	},
	/*****
	**优惠券
	******/
	couponUnse(url,params){
		return http.get(`/coupon/unused${url}`,params)
	},
	/*****
	**小样图下载记录
	******/
	getSample(params){
		return http.get(`/user/sample/get`,params)
	},
	/*****
	**头像
	******/
	getUerIcon(params){
		return http.post(`/user/update/userIcon2`,params)
	},
	/*****
	**完善个人信息
	******/
	editUserInfo(params){
		return http.post(`/user/update`,params)
	},
	/*****
	**微信解绑
	******/
	unbindWechat(params){
		return http.get(`/oauth2/unbind/wechat`,params)
	},
	/*****
	**修改邮箱
	******/
	changeEmail(params){
		return http.post(`/changeEmail`,params)
	},
	/*****
	**修改密码
	******/
	changePassword(params){
		return http.post(`/changePassword`,params)
	},
	/*****
	**修改手机号
	******/
	changeMobile(params){
		return http.post(`/passport/changeMobile`,params)
	},
	/*****
	**@favorite
	**收藏夹
	******/
	getWishList(params){
		return http.get(`/wish/list/100/0`,params)
	},
	/*****
	**收藏夹列表
	******/
	getWishDetail(params){
		return http.get(`/wish/detail/100/0`,params)
	},
	/*****
	**收藏夹列表
	******/
	getWish(url,params){
		return http.post(`/wish${url}`,params)
	},
	/*****
	**收藏夹列表
	******/
	wishSave(params){
		return http.post(`/wish/save`,params)
	},
	/*****
	**收藏夹列表
	******/
	wishUpdate(params){
		return http.post(`/wish/update`,params)
	},
	/*****
	**删除收藏夹
	******/
	delWish(params){
		return http.post(`/wish/delete`,params)
	},
    /*****
    **退出
    ******/
    getLogout(params){
    	return http.get(`/logout`,params)
    },
    /*****
    **获取验证码
    ******/
    getCodeImg(params){
    	return http.get('/code'+'?n=' + encodeURIComponent(Math.random()))
    },
    /*****
    **获取用户信息
    ******/
    getInfo(params){
    	return http.get('/system/user/getInfo'+'?n=' + encodeURIComponent(Math.random()))
    },
}
